import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { Search } from "@organic-return/foundation-react/src/components/Search/Search"
import { useSiteContext } from "../common/SiteContext"
import truncate from "truncate-html"
import { AgilityImage } from "@agility/gatsby-image-agilitycms"

const BuildersSearch = ({ module, page }) => {
  const siteContext = useSiteContext()
  const data = useStaticQuery(graphql`
    query {
      allAgilityBuilders(sort: {fields: customFields___builderName, order: ASC}) {
        nodes {      
          customFields {        
            builderDescription
            builderLogo {              
              url
              filesize
              height
              pixelHeight
              pixelWidth
              width
            }
            builderName
          }
          path
        }
      }
    }
  `)

  // Configurable results per page defaults to 20
  let pageSize = module.customFields?.pageSize || 0
  return (
    <Search
      index={data.allAgilityBuilders.nodes}
      pageSize={pageSize}
      showCount={true}
      renderItem={(item, index) => {
        return (
          <div key={index} className="flex flex-col gap-y-4 w-full sm:w-1/2 lg:w-1/4 xl:w-1/5 p-4">
            <Link className="bg-white" to={item.path}>
              {item.customFields.builderLogo?.url && (
                <AgilityImage
                  image={{
                    ...item.customFields.builderLogo,
                  }}
                  class="w-full aspect-square"
                  imgStyle={{ objectFit: "contain", objectPosition: "center", width: "100%" }}
                />
              )}
            </Link>
            <h3 className="font-black text-xl uppercase leading-9 tracking-widest">{item.customFields.builderName}</h3>
            <div className="font-medium leading-7 tracking-widest" dangerouslySetInnerHTML={{ __html: truncate(item.customFields.builderDescription, 88) }}>
            </div>
            <Link
              to={item.path}
              children="View Builder"
              className="self-start font-black tracking-widest px-6 py-2 text-xs bg-accent inline-block uppercase text-body-text-inverted"
            />
          </div>
        )
      }}
      preRenderItem={(item, index) => {
        return (
          <a key={index} href={item.path}></a>
        )
      }}
      {...siteContext.buildersSearchProps}
    />
  )
}

export default BuildersSearch
